var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Local de Lotação",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarLotacoes.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.listGres,
      "item-text": 'nome',
      "item-value": 'id',
      "label": "GRE",
      "multiple": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.handleChangeGres,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarLotacoes.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.gres,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "gres", $$v);
      },
      expression: "form.filters.gres"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sca-select-ativo', {
    attrs: {
      "cols": 5,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarLotacoes
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.filteredListMunicipios,
      "item-text": 'nome',
      "item-value": 'codigo',
      "label": "Município",
      "multiple": "",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    on: {
      "change": _vm.handleChangeMunicipios,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarLotacoes.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.municipios,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "municipios", $$v);
      },
      expression: "form.filters.municipios"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarLotacoes();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterLotacao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listLotacoes,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": "Não há registros a serem exibidos."
    },
    scopedSlots: _vm._u([{
      key: `item.ativo`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarLotacao(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterLotacao(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarLotacao(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogManterLotacao.visible ? _c('CadastrarEditarLotacaoDialog', {
    attrs: {
      "visible": _vm.dialogManterLotacao.visible,
      "content": _vm.dialogManterLotacao.content,
      "edit": _vm.dialogManterLotacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterLotacao.close();
      },
      "onSave": function ($event) {
        return _vm.buscarLotacoes();
      }
    }
  }) : _vm._e(), _c('VisualizarLotacaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarLotacao.visible,
      "content": _vm.dialogVisualizarLotacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarLotacao.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }